import { roundToDecimals } from "../../../helpers/FormatHelper";
import { saveBNAdjustment, voidBNAdjustment } from "../../../networking/NetworkingBNAdjustment";

 export const calculateBuyAmount = (rateTerms, rate, amount, buyScale ) => {
  let buyAmount = 0;
  if(rate > 0)
  {
    if (rateTerms === 'I') {
        buyAmount = amount / rate;
     
    } else {
        buyAmount= amount * rate;      
    }
  }
    return  roundToDecimals(buyAmount, buyScale);
  
  };

    export const calculateTotalAmounts = (adjustmentRows) =>{
    let buyAmount = 0;

    if(adjustmentRows)
    {
        adjustmentRows.forEach((d)=>{
            buyAmount += d.BuyAmount;
        })
    }
    return {BuyAmount: buyAmount};
} 

export const voidAdjustment = async(adjustmentID) =>{
  const responseOrder = await voidBNAdjustment(adjustmentID);

  if(responseOrder.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: responseOrder.Message, Success: false, OrderNo:0}
  }
  else{
    return {Title: 'Success', Message: 'Order was void successfully', Success: true}
  }
}

const getAdjustmentRowsToSave = (adjustmentRows) =>{

  const adjustmentRowsToSave = [] ;
  if(adjustmentRows)
  {
    adjustmentRows.forEach((o, index) =>{
      const newRow = {
        ItemNo: index+1,
        CurrencyID: o.CurrencyID,
        AdjustmentType: o.AdjustmentType,
        ForeignAmount: o.Amount,
        CostRate: o.CostRate,
        BaseAmount: o.BuyAmount,
        Comments: o.Comments
      }
      adjustmentRowsToSave.push(newRow);
      })
  }
  return adjustmentRowsToSave
}

const getOrderToSave = (objAdjustment, userID)=>
{
    return {
    AdjustmentID: objAdjustment.AdjustmentID,
    VaultID: objAdjustment.VaultID,
    ReferenceType: objAdjustment.ReferenceType,
    ReferenceID: objAdjustment.ReferenceID,
    ReferenceDate: new Date(objAdjustment.ReferenceDate),
    AccountingDate: new Date(objAdjustment.AccountingDate),
    TotalAdjusted: objAdjustment.TotalAdjusted,
    CurrencyID: objAdjustment.CurrencyID,
    Comments: objAdjustment.Comments,
    UserID: userID,
    Status: objAdjustment.Status,
    AdjustmentRows: getAdjustmentRowsToSave(objAdjustment.AdjustmentRows)
  }
}

export const save = async(objAdjustment, comments, userID) =>{
   
  objAdjustment.Comments = comments;

  const adjustment = getOrderToSave(objAdjustment, userID);
    console.log(adjustment);
  const responseSave = await saveBNAdjustment(adjustment);

  console.log(responseSave);
  if(responseSave.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: responseSave.Message, Success: false, OrderNo:0}
  }
  else{
    const messageSave = 'Adjustment was saved successfully';
    return {Title: 'Success', Message: messageSave, Success: true, AdjustmentID: responseSave.AdjustmentID}
  }
}
